import React from "react";
import { Maximize2, TrendingUp } from "lucide-react";

const Tile = ({ onClick, testId, className, imgSrc, children }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`group relative rounded-2xl overflow-hidden border border-white/[0.08] hover:border-brand-orange/40 transition-all ${className}`}
  >
    <img src={imgSrc} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent" />
    {children}
  </button>
);

const ZoomBadge = () => (
  <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/55 backdrop-blur border border-white/15 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
    <Maximize2 className="w-4 h-4" />
  </div>
);

export const ProjectGallery = ({ project, isDE, openLightbox }) => (
  <section className="px-6 md:px-12 lg:px-24 mb-20" data-testid="gallery-section">
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-12 h-px bg-brand-orange" />
        <span className="label-mono">{isDE ? "Visuelle Galerie" : "Visual gallery"}</span>
      </div>
      <h2 className="font-display font-bold text-3xl md:text-4xl text-white tracking-tight mb-8">
        {isDE ? "Detail-Ansichten der Lösung." : "Detail views of the solution."}
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        <Tile
          onClick={() => openLightbox(1)}
          testId="gallery-tile-0"
          className="col-span-2 md:col-span-2 md:row-span-2 aspect-[4/3] md:aspect-[16/12]"
          imgSrc={project.assets.gallery[0]}
        >
          <div className="absolute bottom-3 left-4 label-mono text-white/85">{isDE ? "Kerninterface" : "Core interface"}</div>
          <ZoomBadge />
        </Tile>
        <Tile
          onClick={() => openLightbox(2)}
          testId="gallery-tile-1"
          className="aspect-square"
          imgSrc={project.assets.gallery[1]}
        >
          <div className="absolute bottom-3 left-4 label-mono text-white/85">{isDE ? "Workflow" : "Workflow"}</div>
        </Tile>
        <Tile
          onClick={() => openLightbox(3)}
          testId="gallery-tile-2"
          className="aspect-square"
          imgSrc={project.assets.gallery[2]}
        >
          <div className="absolute bottom-3 left-4 label-mono text-white/85">{isDE ? "Integrationen" : "Integrations"}</div>
        </Tile>
        <Tile
          onClick={() => openLightbox(4)}
          testId="gallery-tile-3"
          className="col-span-2 md:col-span-3 aspect-[16/7]"
          imgSrc={project.assets.dashboard}
        >
          <div className="absolute bottom-3 left-4 flex items-center gap-2">
            <TrendingUp className="w-4 h-4 text-brand-orange" />
            <div className="label-mono text-white/85">{isDE ? "Ergebnis-Dashboard" : "Results dashboard"}</div>
          </div>
          <ZoomBadge />
        </Tile>
      </div>
    </div>
  </section>
);
